<template>
  <div>
    <v-table
      :count="count"
      :list="list"
      :is-loading="isLoading"
      :is-show-state="true"
      :query-list="queryList"
      :push-list="RouteConfig.teacherAddApplyList.push"
    >
      <v-column-time value="申请时间"/>
      <v-column-avatar label="申请人员" avatar-key="admin_avatar" nickname-key="admin_nickname"/>
      <el-table-column
        v-if="isAdministrator"
        label="申请门店"
        width="150"
        align="center"
        prop="store_name"
      />
      <v-column-avatar label="老师昵称"/>
      <el-table-column
        label="手机号"
        width="150"
        align="center"
        prop="phone"
      />
      <el-table-column
        label="企业微信"
        width="150"
        align="center"
        prop="we_chat"
      />
      <el-table-column label="审核状态" width="150" align="center" prop="updateState">
        <template v-slot="{ row }">
          <span v-for="state in findApplyState(row.state)" :key="`teacher-add-apply-state-${state.value}`">
            <el-tag :type="state.tagType">{{ state.name }}</el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template v-slot="{ row }">
          <v-list-button
            name="查看"
            icon="view"
            :to="RouteConfig.teacherAddApplyDetail.to(row.id)"
          />

          <v-list-button
            v-if="!isAdministrator && row.state === applyStates.review.value"
            name="撤销"
            icon="restore"
            @click="handleRevoke(row)"
            :is-loading="isRevokingIds.includes(row.id)"
            message="确定要撤销申请吗？"
          />
        </template>
      </el-table-column>

      <template slot="mobile-list">
        <section class="list">
          <template v-if="list.length">
            <div
              v-for="(v, k) in list"
              :key="`teacher-add-apply-list-${k}-${v.id}`"
              class="list-item primary-background-light"
            >
              <div class="list-item-detail">
                <span>申请时间</span>
                <span>{{ v.add_time | timeToYmdHi }}</span>
              </div>

              <div class="list-item-detail">
                <span>申请人员</span>
                <v-avatar-nickname
                  :value="v.admin_avatar"
                  :nickname="v.admin_nickname"
                  :is-center="true"
                  :avatar-size="50"
                  width="30vw"
                />
              </div>

              <div v-if="isAdministrator" class="list-item-detail">
                <span>申请门店</span>
                <span>{{ v.store_name }}</span>
              </div>

              <div class="list-item-detail">
                <span>老师昵称</span>
                <span>{{ v.nickname }}</span>
              </div>

              <div class="list-item-detail">
                <span>老师头像</span>
                <v-avatar :value="v.avatar" :size="50"/>
              </div>

              <div class="list-item-detail">
                <span>手机号</span>
                <span>{{ v.phone }}</span>
              </div>

              <div class="list-item-detail">
                <span>企业微信</span>
                <span>{{ v.we_chat }}</span>
              </div>

              <div class="list-item-detail">
                <span>审核状态</span>
                <span v-for="state in findApplyState(v.state)" :key="`teacher-add-apply-state-${state.value}`">
                  <el-tag :type="state.tagType">{{ state.name }}</el-tag>
                </span>
              </div>

              <div class="list-item-button">
                <v-list-button
                  name="查看"
                  icon="view"
                  :to="RouteConfig.teacherAddApplyDetail.to(v.id)"
                />

                <v-list-button
                  v-if="!isAdministrator && v.state === applyStates.review.value"
                  name="撤销"
                  icon="restore"
                  @click="handleRevoke(v)"
                  :is-loading="isRevokingIds.includes(v.id)"
                  message="确定要撤销申请吗？"
                />
              </div>
            </div>
          </template>

          <v-empty :is-loading="isLoading" :length="list.length"/>
        </section>
      </template>


    </v-table>
  </div>

</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { applyStates, findApplyState } from '@/enums/applyStates';
import { index, destroy } from '@/api/teacher-add-apply';
import { removeArrayItem } from '@/utils';
import { getLegalQueryList } from "@/utils/formats";

export default {
  name: RouteConfig.teacherAddApplyList.name,
  data: () => ({
    RouteConfig,
    count: 0,
    list: [],
    stores: [],
    queryList: {
      is_asc: 0,
      state: applyStates.review.value,
      page: 1,
      size: 8,
    },
    isLoading: false,
    isDetailLoading: false,
    isShowDialog: false,
    isShowPassAllTip: false,
    isPassingAll: false,
    isRevokingIds: [],
    isPassingIds: [],
    isRejectingIds: [],
    applyInfo: {
      id: 0,
      state: applyStates.review.value,
    },
    applyStates,
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
      'userStoreId',
    ]),
  },
  methods: {
    findApplyState,
    refresh() {
      RouteConfig.teacherAddApplyList.push(this.queryList);
    },
    closeModal(id) {
      if (this.applyInfo.id !== id) return;
      this.applyInfo.id = 0;
      this.isShowDialog = false;
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;

      getLegalQueryList(queryList, query);
      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleRevoke({ id }) {
      this.isRevokingIds.push(id);
      const { isError } = await destroy(id);
      removeArrayItem(this.isRevokingIds, id);
      if (isError) return;

      this.closeModal(id);
      this.load();
    },
  },
  beforeMount() {
    this.load();
  },
};
</script>

